module.exports = __webpack_public_path__ + "static/media/cartao-visita-medcopa1-768x591.68990aaa.jpg";